import React, { createContext, useState, useContext, useCallback } from 'react';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toastState, setToastState] = useState({
    visible: false,
    type: null, // 'success' or 'error'
    message: ''
  });

  const showToast = useCallback((type, message) => {
    setToastState({ visible: true, type, message });
  }, []);

  const hideToast = useCallback(() => {
    setToastState({ visible: false, type: null, message: '' });
  }, []);

  return (
    <ToastContext.Provider value={{ toastState, showToast, hideToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}; 